module.exports = __webpack_public_path__ + "static/media/Brittany Truex.1288a9b9.png";